import AxiosInstance from "../components/ui/AxiosInterceptorsWrapper";

export class BaseService {
  protected readonly http = AxiosInstance;

  constructor(protected readonly endpointPath: string) {}
}
